import { atlasRoutes } from "@/app/router/routes";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";
import { FC } from "react";
import { useNavigate } from "react-router";

export const SyncOperationsRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>SyncOperationsRootPage</h1>

      <LookupByUuidForm
        onSubmit={uuid =>
          navigate(atlasRoutes.syncOperationsView({ params: { syncOperationId: uuid } }).path)
        }
      />
    </div>
  );
};
